module.exports = __webpack_public_path__ + "media/virelai_des_marees.8ad61d61.mp3";